'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
const defaultOptions: globalThis.PositionOptions = {
  enableHighAccuracy: true,
  timeout: 10000,
  // 10 seconds
  maximumAge: 300000 // 5 minutes
};
export const useCurrentLocation = options => {
  const $ = _c(7);
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  let t0;
  if ($[0] !== options) {
    t0 = () => {
      if (!navigator.geolocation) {
        setError("Geolocation not supported");
        return Promise.reject("Geolocation not supported");
      }
      setError(null);
      setLoading(true);
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(pos => {
          const newLocation = {
            lat: +pos.coords.latitude,
            lng: +pos.coords.longitude
          };
          setLocation(newLocation);
          setLoading(false);
          resolve(newLocation);
        }, err => {
          setError(err.message);
          setLoading(false);
          if (err.code === 1) {
            return resolve({
              lat: 0,
              lng: 0
            });
          }
          reject(err);
        }, {
          ...defaultOptions,
          ...options
        });
      });
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getLocation = t0;
  let t1;
  if ($[2] !== error || $[3] !== getLocation || $[4] !== loading || $[5] !== location) {
    t1 = {
      currentLocation: location,
      error,
      loading,
      getLocation
    };
    $[2] = error;
    $[3] = getLocation;
    $[4] = loading;
    $[5] = location;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};